// ClientHeaderWrapper.jsx
'use client'
import { useEffect } from 'react'
import Header from './Header'
import HeaderSafe from './HeaderSafe'
import { isSafeCountry } from '../../helpers/helpers'
import { safeSetItem } from '../../helpers/safeStorage'
import { useChromeless } from '../useChromeless'
import useAttributionAllowed from '../../hooks/useAttributionAllowed'

const ClientHeaderWrapper = () => {
  const safeCountry = isSafeCountry()
  const chromeless = useChromeless()
  // Always true unless the strict consent switch is on (useAttributionAllowed.js): then the Crak ids wait for consent.
  const allowed = useAttributionAllowed()

  useEffect(() => {
    if (!allowed) return
    // NOTE: replaying the `pc_ref` referral cookie into localStorage, and reporting an Aiffiliate
    // link's click, are NOT done here — they run in <ReferralHydrator>, which the root layout
    // renders outside the auth gate. This component is inside the gate, so on auth-gated
    // destinations it wouldn't mount until Firebase resolved. The once-per-session
    // /api/record-event ping that lived here went on 7 October 2026: it counted the same visitor
    // again every session (lib/hydrate-referral.js), and the backend only ever forwarded its
    // Aiffiliate part.

    // --- Exact Crak inbound param capture ---
    try {
      const params = new URLSearchParams(window.location.search)

      const ref = params.get('ref')

      if (ref) {
        safeSetItem('ref', ref)
      }

      if (ref === 'cr') {
        const crTransactionId = params.get('cr_transaction_id')
        const crAffiliateId = params.get('cr_affiliate_id')
        const crSource = params.get('cr_source')

        // store Crak-specific params for backend use later
        if (crTransactionId) safeSetItem('cr_transaction_id', crTransactionId)
        if (crAffiliateId) safeSetItem('cr_affiliate_id', crAffiliateId)
        if (crSource) safeSetItem('cr_source', crSource)
      }
    } catch (e) {
      console.error(e)
    }
  }, [allowed])

  // Returned AFTER the effect above, never before it: the referral capture
  // must still run for a Telegram user. Only the chrome is suppressed, not the
  // tracking.
  if (chromeless) return null

  return safeCountry ? <HeaderSafe /> : <Header />
}

export default ClientHeaderWrapper
